var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"opz2-empty"},[_c('div',{staticClass:"opz2-empty__icon"},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"opz2-empty__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.hint)?_c('div',{staticClass:"opz2-empty__hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }